<div class="modal fade" id="modal-payment-options" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="paymentOptionsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
              <h1 class="modal-title fs-5" id="paymentOptionsModalLabel">Como deseja pagar?</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
          </div>
          <div class="modal-body">
              <div class="options">
                  <div class="form-check" *ngFor="let option of options">
                      <input
                          class="form-check-input"
                          type="radio"
                          name="paymentOption"
                          [id]="option"
                          [value]="option"
                      />
                      <label class="form-check-label pt-1" [for]="option">
                          {{ option }}
                      </label>
                  </div>
              </div>
          </div>
          <div class="modal-footer">
              <app-button
                  class="mx-2 my-1"
                  id="confirmModalBtn"
                  [buttonOptions]="confirmBtn"
                  (buttonClick)="onConfirm()">
              </app-button>
          </div>
      </div>
  </div>
</div>